<template>
<div>
  <v-card class='hidden-ios-true hidden-android-true' >
    <v-card-text>
      <h3 class='headline'>Get the app</h3>
    </v-card-text>
    <v-card-text>
      <p class='subheading'>Download the AppointmentGuru app on your phone so you can manage everything on the go!</p>

      <v-btn
        v-if='installer'
        @click='installMobile' color='primary' >Install on this device</v-btn>

      <v-subheader class='overline pl-0' >To install on iOS: </v-subheader>
      <li>Click on the share icon <v-icon small >ios_share</v-icon></li>
      <li>Scroll and click on "add to home screen"</li>

      <v-subheader class="overline pl-0" >To install on Android: </v-subheader>
      <p>If you visit
        <a href="https://app.appointmentguru.co" >app.appointmentguru.co</a>
        you should be prompted to install the app
      </p>
      <strong class='overline' >If not, try this:</strong>
      <li>Click on the three dots (top right in Chrome)</li>
      <li>Click on "Install app"</li>
      <!-- <v-img
          class='mt-3 mx-3 hidden-sm-and-up'
          src='/static/img/pwa.png' @click='installMobile' /> -->
      <!-- <a href='https://apps.apple.com/us/app/appointmentguru-mypractice/id1186604931' target='_blank' >
      <img class='store-link' src='/static/img/app-store.png' ></a>
      <a href='https://play.google.com/store/apps/details?id=za.co.AppointmentGuru.practitioner' target='_blank' >
        <img class='store-link' src='/static/img/play-store.png' ></a> -->
    </v-card-text>
  </v-card>
  <v-card class='mt-3' >
    <v-card-text>
      <h3 class='headline'>Calender</h3>
      <p class='subheading'>Use the address below to sync your AppointmentGuru calendar to your phone calendar app.</p>
    </v-card-text>
    <v-card-text>
      <copy-text-field
        label='Your calendar address'
        hint='Add your calendar feed to pull your AppointmentGuru appointments into your calendar of choice'
        :text-to-copy='feedUrl' />
      <!-- <v-text-field label='Your calendar address' v-model='feedUrl' :disabled="true" ></v-text-field> -->
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat
        href='https://appointmentguru.co/help/sync-to-a-phone-calendar-app/'
        target='_blank' >More info <v-icon>open_in_new</v-icon></v-btn>
    </v-card-actions>
  </v-card>
</div>
</template>

<script>
import CopyTextField from '@/components/ui/CopyTextField.vue'

export default {
  name: 'CalendarFeed',
  components: {CopyTextField},
  computed: {
    me () {
      return this.$store.getters.me
    },
    feedUrl () {
      let token = this.me.channel.replace('practitioner-', '')
      return `https://appt.guru/ical/practitioner/${token}/`
    },
    installer () {
      return window.guruinstaller
    }
  },
  methods: {
    installMobile () {
      if (window.guruinstaller && window.guruinstaller.prompt) {
        window.guruinstaller.prompt()
      } else {
        this.showInstallInstructions = true
      }
    }
  }
}
</script>

<style scoped>
.store-link { max-width:150px;}
</style>



// WEBPACK FOOTER //
// Calendar.vue?2c62c1fc